<div class="card">
    <ul class="pt-1 nav nav-tabs">
        <li class="nav-item">
            <a
                    class="nav-link"
                    [routerLink]="['/tiers/fournisseurs/details', reference, 'detail-contenue-apercue']"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"

                    href="javascript:void(0)"
            >
                Aperçu
            </a>
        </li>
        <li class="nav-item">
            <a
                    class="nav-link"
                    [routerLink]="['/tiers/fournisseurs/details', reference, 'detail-contenue-relevéDuCompte']"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"

                    href="javascript:void(0)"
            >
                Relevé du compte
            </a>
        </li>
        <li class="nav-item">
            <a
                    class="nav-link"
                    [routerLink]="['/tiers/fournisseurs/details', reference, 'detail-contenue-document']"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: false }"

                    href="javascript:void(0)"
            >
                Document
            </a>
        </li>
        <li class="nav-item">
            <a
                    class="nav-link"
                    [routerLink]="['/tiers/fournisseurs/details', reference, 'detail-contenue-paimentNonAffectés']"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"

                    href="javascript:void(0)"
            >
                Paiement non affectés
            </a>
        </li>
    </ul>
    <router-outlet></router-outlet>
</div>
